'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fireAnalyticsTrackEvent = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined = require('lodash/isUndefined');

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _events = require('./events');

var _mapDataPayloadToContextPayload = require('./map-data-payload-to-context-payload');

var _mapDataPayloadToContextPayload2 = _interopRequireDefault(_mapDataPayloadToContextPayload);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNotUndefined = function isNotUndefined(a) {
    return !(0, _isUndefined2.default)(a);
};

var mapPayload = function mapPayload(payload) {
    var context = (0, _mapDataPayloadToContextPayload2.default)(payload);
    var action = payload.action,
        actionSubject = payload.actionSubject,
        actionSubjectId = payload.actionSubjectId;

    return (0, _pickBy2.default)((0, _extends3.default)({}, context, context.attributes, {
        attributes: undefined,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId
    }), isNotUndefined);
};

var fireAnalyticsTrackEvent = exports.fireAnalyticsTrackEvent = function fireAnalyticsTrackEvent(event, payload) {
    var clonedEvent = event.clone();
    clonedEvent.update((0, _extends3.default)({}, mapPayload(payload), { analyticsType: _events.TRACK_EVENT_TYPE })).fire();
};